import axios from 'axios'

export default class MedidaInterventiva {
  constructor (tokenBearer, url, id) {
    this.url = url
    this.tokenBearer = tokenBearer
    this.id = id
  }

  getMedidaInterventiva (args = '') {
    let url = `${this.url}/api/unimed/medidasInterventivas/${this.id}?${args}`
    return new Promise(async (resolve, reject) => {
      let optionsMedidaInterventiva = {
        method: 'get',
        url,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let responseMedidaInterventiva = await axios(optionsMedidaInterventiva)
        resolve(responseMedidaInterventiva)
      } catch (err) {
        reject(err)
      }
    })
  }

  putMedidaInterventiva (medidaInterventiva) {
    let url = `${this.url}/api/unimed/medidasInterventivas/${this.id}`
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'put',
        url,
        headers: {
          'Authorization': this.tokenBearer
        },
        data: medidaInterventiva
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  deleteMedidaInterventiva (medidaInterventidaId) {
    let url = `${this.url}/api/unimed/medidasInterventivas/${this.id}`
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'delete',
        url,
        headers: {
          'Authorization': this.tokenBearer
        },
        data: medidaInterventidaId
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }
}
